import { createContext, useCallback, useContext, useRef, useState } from 'react';

const ToastContext = createContext({ success: () => {}, error: () => {} });

let seed = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const dismiss = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  const push = useCallback(
    (type, message) => {
      const id = ++seed;
      setToasts((t) => [...t, { id, type, message }]);
      timers.current[id] = setTimeout(() => dismiss(id), 3500);
    },
    [dismiss],
  );

  const success = useCallback((m) => push('success', m), [push]);
  const error = useCallback((m) => push('error', m), [push]);

  return (
    <ToastContext.Provider value={{ success, error }}>
      {children}
      <div className="no-print fixed top-4 right-4 z-[100] flex w-80 flex-col gap-2">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`card flex items-start gap-3 px-4 py-3 shadow-pop ${
              t.type === 'success' ? 'border-green-200 bg-success-50' : 'border-red-200 bg-danger-50'
            }`}
          >
            <span className={`mt-0.5 text-lg ${t.type === 'success' ? 'text-success-600' : 'text-danger-600'}`}>
              {t.type === 'success' ? '✓' : '✕'}
            </span>
            <p className={`flex-1 text-sm font-medium ${t.type === 'success' ? 'text-green-900' : 'text-red-900'}`}>
              {t.message}
            </p>
            <button onClick={() => dismiss(t.id)} className="text-content-subtle hover:text-content-muted">
              ✕
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);